import React, { Component } from 'react';
import { string, func } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { lazyLoadWithDimensions } from '../../util/contextHelpers';
import { LINE_ITEM_DAY, LINE_ITEM_NIGHT, propTypes } from '../../util/types';
import { formatMoney } from '../../util/currency';
import { ensureListing, ensureUser } from '../../util/data';
import { richText } from '../../util/richText';
import { createSlug } from '../../util/urlHelpers';
import config from '../../config';
import { NamedLink, ResponsiveImage } from '../../components';

import css from './ListingCard.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 2;

const cityName = (words) => {
  let n = words.split(",");
  let c = n[n.length - 2];

  if (c != undefined) {
    c = c.replace(/\d/g, "");
  }
  else {
    c = "";
  }

  return c.trim();
}

const postalCode = (words) => {
  let n = words.match(/\d{5}/g);
  return n
}


class ListingImage extends Component {
  render() {
    return <ResponsiveImage {...this.props} />;
  }
}
const LazyImage = lazyLoadWithDimensions(ListingImage, { loadAfterInitialRendering: 3000 });

export const ListingCardComponent = props => {
  const { className, rootClassName, intl, listing, renderSizes, setActiveListing } = props;
  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const id = currentListing.id.uuid;
  const { title = '', price } = currentListing.attributes;
  const slug = createSlug(title);

  const firstImage =
    currentListing.images && currentListing.images.length > 0 ? currentListing.images[0] : null;

  const category = currentListing && currentListing.attributes.publicData.category


  return (
    <NamedLink className={classes} name="ListingPage" params={{ id, slug }}>
      <div
        className={css.threeToTwoWrapper}
        onMouseEnter={() => setActiveListing(currentListing.id)}
        onMouseLeave={() => setActiveListing(null)}
      >
        <div className={css.aspectWrapper}>
          <LazyImage
            rootClassName={css.rootForImage}
            alt={title}
            image={firstImage}
            category={category}
            variants={['landscape-crop', 'landscape-crop2x']}
            sizes={renderSizes}
          />
          {
            currentListing.attributes.price &&
            <div className={css.priceBox}>
              <span>{formatMoney(intl, currentListing.attributes.price)}{category === "garden_rent" ? ' / j' : category === "classifields" ? "" : "/ nuit"}</span>
            </div>
          }
        </div>
      </div>
      <div className={css.info}>
        <div className={css.mainInfo}>
          <div className={css.title}>
            {title.length > 35 ? title.substring(0, 35) + "..." : title}
          </div>
          <div className={css.authorInfo} style={{ textAlign: 'left' }}>
            <span>{cityName(currentListing.attributes.publicData.location.address)}</span>&nbsp;-&nbsp;
            <span>{postalCode(currentListing.attributes.publicData.location.address)}</span>
          </div>
        </div>
      </div>
    </NamedLink>
  );
};

ListingCardComponent.defaultProps = {
  className: null,
  rootClassName: null,
  renderSizes: null,
  setActiveListing: () => null,
};

ListingCardComponent.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
  listing: propTypes.listing.isRequired,

  // Responsive image sizes hint
  renderSizes: string,

  setActiveListing: func,
};

export default injectIntl(ListingCardComponent);
